import { css } from "styled-components";
import { themeGet } from "styled-system";

const fontFamily = css`
  font-family: ${themeGet("fontFamily")};
`;

export default fontFamily;
